import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
const FormsScriptBetaAlert = () => /*#__PURE__*/_jsx(Alert, {
  type: "warning",
  titleText: I18n.text('editor.scriptBetaAlert.title'),
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "editor.scriptBetaAlert.description"
  })
});
export default FormsScriptBetaAlert;